export const rejectDataHandler = (payload) => {
  const { data, status } = payload;
  return data?.data?.data.map((item) => {
    return { ...item, status };
  });
};
